import { render, staticRenderFns } from "./UserSettingsTabs.vue?vue&type=template&id=8c1b53b8&"
import script from "./UserSettingsTabs.vue?vue&type=script&lang=js&"
export * from "./UserSettingsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports